import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Mail } from 'lucide-react';

export default function Footer() {
  const [journalInfo, setJournalInfo] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/journal-info`).then(r => r.json()).then(setJournalInfo).catch(() => {});
  }, []);

  return (
    <footer className="bg-slate-dark text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-sm bg-white/10 flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-trans-blue" strokeWidth={1.5} />
              </div>
              <div>
                <span className="font-serif font-bold text-lg">Archivos Trans</span>
                <p className="text-xs text-gray-400 tracking-widest uppercase">ALET</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-md font-sans">
              Archivos Latinoamericanos de Estudios Trans es una revista cientifica de alto impacto dedicada a la
              publicacion de investigacion original en el campo de los estudios trans y la salud de personas de genero diverso.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <div className="h-0.5 w-12 bg-trans-blue rounded-full" />
              <div className="h-0.5 w-8 bg-trans-pink rounded-full" />
              <div className="h-0.5 w-4 bg-white/30 rounded-full" />
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-sans font-semibold text-sm tracking-wide uppercase text-gray-300 mb-4">Navegacion</h4>
            <div className="flex flex-col gap-2">
              <Link to="/archivo" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Archivo</Link>
              <Link to="/pagina/quienes-somos" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Quienes Somos</Link>
              <Link to="/pagina/lineamientos" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Lineamientos</Link>
              <Link to="/contacto" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Contacto</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-sans font-semibold text-sm tracking-wide uppercase text-gray-300 mb-4">Legal</h4>
            <div className="flex flex-col gap-2">
              <Link to="/pagina/aviso-de-privacidad" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Aviso de Privacidad</Link>
              <Link to="/pagina/proteccion-de-datos" className="text-sm text-gray-400 hover:text-white transition-colors font-sans">Proteccion de Datos</Link>
              <a href="mailto:contacto@archivostrans.com" className="text-sm text-gray-400 hover:text-white transition-colors font-sans flex items-center gap-2">
                <Mail className="w-4 h-4" strokeWidth={1.5} /> contacto@archivostrans.com
              </a>
              <p className="text-sm text-gray-400 font-sans">archivostrans.com</p>
              {journalInfo?.issn && (
                <p className="text-sm text-gray-400 font-sans">ISSN: {journalInfo.issn}</p>
              )}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500 font-sans">&copy; {new Date().getFullYear()} Archivos Latinoamericanos de Estudios Trans. Todos los derechos reservados.</p>
          <div className="flex items-center gap-1">
            <div className="w-16 h-1 rounded-full bg-trans-blue/60" />
            <div className="w-16 h-1 rounded-full bg-trans-pink/60" />
            <div className="w-16 h-1 rounded-full bg-white/20" />
            <div className="w-16 h-1 rounded-full bg-trans-pink/60" />
            <div className="w-16 h-1 rounded-full bg-trans-blue/60" />
          </div>
        </div>
      </div>
    </footer>
  );
}
